import Japanese from "./Japanese.json";
import Korean from "./Korean.json";
import English from "./English.json";
import Hindi from "./Hindi.json";

const stringsArray = {
  japanese: Japanese,
  korean: Korean,
  english: English,
  hindi: Hindi,
};

export default {
  getLocalizationFile: function (key, selectedLang = null) {
    return new Promise(function (resolve) {
      let filename = "";
  
      if (selectedLang) {
        filename = selectedLang.toLowerCase();
      } else {
        const lang =
          navigator.language ||
          navigator.browserLanguage ||
          navigator.userLanguage ||
          navigator.systemLanguage;
  
        const shortLang = lang?.toLowerCase().split("-")[0];
        switch (shortLang) {
          case "ja":
            filename = "japanese";
            break;
          case "ko":
            filename = "korean";
            break;
            case "hi":
            filename = "hindi";
            break;
          case "en":
            filename = "english";
            break;
          default:
            filename = "english";
            break;
        }
      }
  
      const fileContent = stringsArray[filename];
      if (!fileContent) {
        console.warn("⚠️ Localization file not found for:", filename);
        resolve({});
        return;
      }
  
      let data = fileContent[key] || {};
  
      if (key === "localizationKeys" || key === "errorCode") {
        const fallback = stringsArray["english"][key] || {};
        const localized = fileContent[key] || {};
  
        const deepMerge = (base, override) => {
          const result = { ...base };
          for (const k in override) {
            if (
              base[k] &&
              typeof base[k] === "object" &&
              typeof override[k] === "object"
            ) {
              result[k] = deepMerge(base[k], override[k]);
            } else {
              result[k] = override[k];
            }
          }
          return result;
        };
  
        data = deepMerge(fallback, localized);
      }
  
      console.log("✔ Loaded data for", filename, key, ":", data);
      resolve(data);
    });
  }
  
};

